import auth from "@/services/ExerciseInitAuth"
import EventBus from "@/util/event-bus"
import { LIST_EVENTS } from "@/const/list-events.enum"
import AxiosHttp from "@/services/api/util/http-internal";

/**
 * Get presigned upload URL for a video file
 * @param {string} filename - The filename to upload
 * @returns {Promise<Object>} - Returns the presigned URL data and file reference
 */
const createPresignedUpload = (filename) =>
  auth.post(`${process.env.VUE_APP_EXERCISE_API}admin/media-files/create_presigned_upload/`, { filename });

/**
 * Upload a file directly to S3 using presigned URL
 * @param {Object} uploadParams - The upload parameters received from createPresignedUpload
 * @param {File} file - The file to upload
 * @returns {Promise<Object>} - Returns the upload response
 */
const uploadToS3 = (uploadParams, file) => {
  // Create form data with all required fields
  const formData = new FormData();
  
  // Add all fields from the upload_params.fields
  Object.keys(uploadParams.fields).forEach(key => {
    formData.append(key, uploadParams.fields[key]);
  });
  
  // Add the file data as the last form element
  formData.append('file', file);
  
  // Track upload progress
  const config = {
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      EventBus.$emit(LIST_EVENTS.FILE_UPLOAD_PROGRESS, percentCompleted);
    }
  };
  
  // Upload directly to S3 without auth headers
  return auth.postNoAuth(uploadParams.url, formData, config);
};

export default {
  createPresignedUpload,
  uploadToS3
}